// src/js/reducers/index.js
import * as types from "../constants/action-types";

export default function sectionTypeReducer(state = [], action) {
    switch (action.type) {
                
        case types.LOGOUT:
            return []
        case types.LOAD_SECTIONTYPES_SUCCESS:
            return action.sectionTypes;
           
        default:
            return state;
    };
};

